var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.items, function (item, yearIndex) {
    return _c('v-row', {
      key: yearIndex,
      staticClass: "history-list",
      attrs: {
        "justify": yearIndex % 2 == 0 ? 'end' : 'start',
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      staticClass: "year",
      attrs: {
        "flat": "",
        "rounded": "pill",
        "color": "#f7f7f7"
      }
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": "1"
      }
    }, [_vm._v(" " + _vm._s(item.year) + " ")])], 1)], 1), _c('v-col', {
      staticClass: "items",
      class: yearIndex % 2 == 0 ? 'items--odd' : 'items--even',
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-card', {
      attrs: {
        "tile": "",
        "flat": ""
      }
    }, _vm._l(item.items, function (item, index) {
      return _c('v-row', {
        key: index,
        attrs: {
          "no-gutters": ""
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "auto"
        }
      }, [_c('v-sheet', {
        staticClass: "month",
        class: {
          'mt-12': index !== 0
        },
        attrs: {
          "min-width": "24"
        }
      }, [_vm._v(_vm._s(item.month) + "월")])], 1), _c('v-col', [_c('div', {
        staticClass: "gutter",
        class: {
          'mt-12': index !== 0
        }
      }, _vm._l(item.items, function (item, index) {
        return _c('v-row', {
          key: index,
          class: {
            'pt-12': index !== 0
          },
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', [item.date ? _c('span', [_vm._v(_vm._s(item.date) + "일 ")]) : _vm._e(), _c('span', {
          domProps: {
            "innerHTML": _vm._s(item.text)
          }
        })]), item.logo ? [_c('v-col', {
          attrs: {
            "cols": "12",
            "lg": "auto",
            "order-lg": yearIndex % 2 == 0 ? undefined : 'first'
          }
        }, _vm._l(item.logo, function (image, index) {
          return _c('v-img', {
            key: index,
            staticClass: "d-inline-block d-lg-block",
            attrs: {
              "src": image,
              "max-width": "112",
              "alt": ""
            }
          });
        }), 1)] : _vm._e(), item.plus ? _c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('p', {
          staticClass: "primary--text mt-4 text-pre-wrap"
        }, [_vm._v(_vm._s(item.plus))])]) : _vm._e()], 2);
      }), 1)])], 1);
    }), 1)], 1)], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }